module.exports = __webpack_public_path__ + "img/applicants_details.c7700726.svg";